import { CardView } from "../../../../../_components/Abstractions/CardView";
import { useFormContext } from "react-hook-form";
import { Dropdown } from "../../../../../_components/Abstractions/Dropdown";
import { RatePlanType } from "../../../../../domain/RatePlanType";
import { FormControl } from "../../../../../_components/Forms/FormControl";
import { HorizontalView } from "../../../../../_components/Abstractions/HorizontalView";
import { DomainSwitch } from "../../../../../_components/Abstractions/DomainSwitch";
import { AddressMultiSelect } from "../../../../../_components/Addresses/AddressMultiSelect";
import { Alert } from "react-bootstrap";
import { TextArea } from "../../../../../_components/Forms/TextArea";

export function DefinitionRatePlanForm() {
  const { watch, getValues } = useFormContext();
  const intermediaries = getValues("intermediaries");
  const addresses = getValues("addresses");
  const isTypeEditable = getValues("isTypeEditable");
  const isClone = getValues("isClone");
  const isUpdate = getValues("isUpdate");
  const isCreation = !isClone && !isUpdate;
  const isIntermediaryPricing = watch("isIntermediaryPricing");
  const multipleRatePlans = watch("multipleRatePlans");

  return <>
    <CardView headerText="Definicja cennika" headerTypo="h5">
      <Dropdown name="type" label="Typ cennika" items={RatePlanType} readonly={!isTypeEditable}/>
      {!multipleRatePlans &&
        <Dropdown label="Adres" items={addresses} name="addressId" required={false} readonly={!isCreation}/>}
      {multipleRatePlans &&
        <AddressMultiSelect name="addressesIds" label="Adresy" addressesField="addressesList"/>}
      <DomainSwitch name="multipleRatePlans" label="Cenniki dla wielu adresów" readonly={!isCreation}/>
      {multipleRatePlans && <Alert variant="success">
        Ceny towarów zostaną zapisane tylko do tych adresów, które mają je przypisane w załadunku / kontenerach
      </Alert>}
      {(intermediaries && Object.keys(intermediaries).length > 0) &&
      <DomainSwitch name="isIntermediaryPricing" label="Cennik pośrednika" readonly={!isCreation}/>}
      <HorizontalView>
        <FormControl name="dateFrom" label="Data początkowa" inputType="date"/>
        <FormControl name="dateTo" label="Data końcowa" inputType="date" required={false}/>
      </HorizontalView>
      {isIntermediaryPricing && <Dropdown label="Pośrednik" items={intermediaries} name="intermediaryId"/>  }
      <TextArea height={80} name="remarks" label="Uwagi" required={false}/>
    </CardView>
  </>;
}